import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <section
        className="contact-hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/contact.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container">
          <h1 className="page-title">Contact EBTA</h1>
          <p className="hero-subtitle">
            Get in touch with the European Brief Therapy Association
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Contact Information</h2>
              
              <div className="contact-item">
                <h3>General Inquiries</h3>
                <p>📧 <a href="mailto:info@ebta.eu">info@ebta.eu</a></p>
              </div>

              <div className="contact-item">
                <h3>Office Location</h3>
                <p>📍 Lyon, France</p>
                <p><em>The office of EBTA is in Lyon, France. This may be changed by a decision of the Members Annual Meeting.</em></p>
              </div>

              <div className="contact-item">
                <h3>Legal Status</h3>
                <p>EBTA is registered in France and governed by the French law of 1901 July 1st and the Decree of 1901, August 16th.</p>
                <p>Registration accepted: January 14th, 1994</p>
              </div>

              <div className="contact-item">
                <h3>Follow Us</h3>
                <p>🌐 <a href="https://www.facebook.com/ebta.network" target="_blank" rel="noopener noreferrer">Facebook</a></p>
              </div>
            </div>

            <div className="contact-form-section">
              <h2>Send us a Message</h2>
              <div className="contact-form">
                <p>For membership inquiries, conference information, or general questions about EBTA, please contact us at:</p>
                <div className="email-highlight">
                  <a href="mailto:info@ebta.eu" className="email-button">info@ebta.eu</a>
                </div>
                
                <div className="contact-topics">
                  <h3>What can we help you with?</h3>
                  <ul>
                    <li>🎓 Membership applications and information</li>
                    <li>📅 Conference and event inquiries</li>
                    <li>📚 Research and publications</li>
                    <li>🤝 Task group participation</li>
                    <li>💼 Professional networking</li>
                    <li>❓ General questions about solution-focused approaches</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="membership-cta">
            <h2>Interested in Joining EBTA?</h2>
            <p>Members shall be individuals in good professional standing in their country of origin, have basic exposure to solution-focused training or the equivalent (minimum 20 hours) and accept the purpose, goals and rules of EBTA.</p>
            <a href="/membership" className="cta-button">Learn About Membership</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
